import { UserSummaryType } from '../../user/user-summary.type';
import { BaseEntity } from '../../base-entity';

export interface ExternalExamRegistrationStudentDetails
  extends ExternalExamItemRegistrationEntity {
  userDetails: UserSummaryType;
}

export interface ExternalExamItemRegistrationEntity extends BaseEntity {
  id: number;
  externalExamId: number;
  externalExamGroupId: number;
  userId: number;
  branchId: number;
  programId: number;
  actionNumber: string | null;
  paymentExempted: boolean;
  /*isRegister: boolean;*/
  eligibilityStatus: EligibilityStatus;
  registrationSourceType: RegistrationSourceType;
  attended: boolean | null;
  internalGrade: number | null;
  externalGrade: number | null;
  finalGrade: number | null;
}

export enum EligibilityStatus {
  ELIGIBILITY = 'eligibility',
  REGISTER = 'register',
  CANCELED = 'canceled',
}

export enum RegistrationSourceType {
  SELF = 'self',
  ADMIN = 'admin',
}
